
<ElFormItem
    v-if="!insetHide"
    :class="`condition-item condition-item--cascader condition-item--${field} condition-item--${!!postfix}`"
    v-bind="formItemProps"
    :prop="formItemProps.prop || field"
>
    <ElCascader
        v-bind="contentProps"
        v-on="$listeners"
        :props="customProps"
        :disabled="insetDisabled"
        :options="finalOption"
        :value="checked"
        class="condition-item__content"
        @change="change"
    ></ElCascader>
    <div v-if="postfix" class="condition-item__postfix">
        <template v-if="typeof postfix === 'string'">{{ postfix }}</template>
        <template v-else><component :is="getNode(postfix, checked)"></component></template>
    </div>
</ElFormItem>
